import { render, staticRenderFns } from "./NsMenuItem.vue?vue&type=template&id=06ce506d&scoped=true"
import script from "./NsMenuItem.vue?vue&type=script&lang=js"
export * from "./NsMenuItem.vue?vue&type=script&lang=js"
import style0 from "./NsMenuItem.vue?vue&type=style&index=0&id=06ce506d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce506d",
  null
  
)

export default component.exports